import { call, put, takeEvery } from "redux-saga/effects"
import Moment from "moment"

// Staff Redux States
import {
  GET_HOUSEHOLDS,
  GET_HOUSEHOLD_DETAIL,
  ADD_HOUSEHOLD,
  UPDATE_HOUSEHOLD,
  GET_TRAININGMONTHS,
  GET_TRAININGSUBJECTS,
  GET_TRAININGTYPES,
  ADD_HOUSEHOLD_FILEUPLOAD,
  ADD_HOUSEHOLD_DATAUPLOAD,
  ADD_SUBJECT,
  UPDATE_SUBJECT,
  GET_SUBJECT_DETAIL,
} from "./actionTypes"
import {
  getHouseholdsSuccess,
  getHouseholdsFail,
  getHouseholdDetailSuccess,
  getHouseholdDetailFail,
  addHouseholdSuccess,
  addHouseholdFail,
  updateHouseholdSuccess,
  updateHouseholdFail,
  getTrainingMonthsSuccess,
  getTrainingMonthsFail,
  getTrainingSubjectsSuccess,
  getTrainingSubjectsFail,
  getTrainingTypesSuccess,
  getTrainingTypesFail,
  addHouseholdFileUploadSuccess,
  addHouseholdFileUploadFail,
  addHouseholdDataUploadSuccess,
  addHouseholdDataUploadFail,
  addSubjectSuccess,
  addSubjectFail,
  updateSubjectSuccess,
  updateSubjectFail,
  getSubjectDetailSuccess,
  getSubjectDetailFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getHouseholds,
  getHouseholdDetail,
  addHousehold,
  updateHousehold,
  getTrainingMonths,
  getTrainingTypes,
  getTrainingSubjects,
  addHousholdFile,
  addHousholdDataUpload,
  addSubject,
  updateSubject,
  getSubjectDetail,
} from "helpers/backend_helper"

// toast
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

function* fetchHouseholds() {
  try {
    const response = yield call(getHouseholds)
    yield put(getHouseholdsSuccess(response))
  } catch (error) {
    yield put(getHouseholdsFail(error))
  }
}

function* onAddHousehold({ payload: household }) {
  try {
    const response = yield call(addHousehold, household)
    yield put(addHouseholdSuccess(response))
  } catch (error) {
    yield put(addHouseholdFail(error))
  }
}

function* onUpdateHousehold({ payload: household }) {
  try {
    const response = yield call(updateHousehold, household)
    yield put(updateHouseholdSuccess(response))
  } catch (error) {
    yield put(updateHouseholdFail(error))
  }
}

function* fetchHouseholdDetail({ rowID }) {
  try {
    const response = yield call(getHouseholdDetail, rowID)
    let result = response

    result = {
      ...result,
      TrainingMonths: {
        TrainingMonthID: result.TrainingMonthID,
        TrainingMonth: result.TrainingMonth,
      },
      TrainingTypes: {
        TrainingTypeID: result.TrainingTypeID,
        TrainingType: result.TrainingType ?? "Select...",
      },
      TrainingDate: result.TrainingDate
        ? Moment(result.TrainingDate).format("DD MMM, YYYY")
        : "",
    }
    yield put(getHouseholdDetailSuccess(result))
  } catch (error) {
    yield put(getHouseholdDetailFail(error))
  }
}

function* fetchTrainingMonths() {
  try {
    const response = yield call(getTrainingMonths)
    yield put(getTrainingMonthsSuccess(response))
  } catch (error) {
    yield put(getTrainingMonthsFail(error))
  }
}

function* fetchTrainingTypes() {
  try {
    const response = yield call(getTrainingTypes)
    yield put(getTrainingTypesSuccess(response))
  } catch (error) {
    yield put(getTrainingTypesFail(error))
  }
}

function* fetchTrainingSubjects({ payload: active }) {
  try {
    let response = yield call(getTrainingSubjects)
    if (active) {
      response = response.filter(x => x.Active === true)
    }

    yield put(getTrainingSubjectsSuccess(response))
  } catch (error) {
    yield put(getTrainingSubjectsFail(error))
  }
}

function* onAddHouseholdBulkFile({ payload: file }) {
  try {
    var formData = new FormData()
    formData.append("FileName", file)
    const response = yield call(addHousholdFile, formData)
    yield put(addHouseholdFileUploadSuccess(response))
  } catch (error) {
    yield put(addHouseholdFileUploadFail(error))
  }
}

function* onAddHousholdDataUpload() {
  try {
    const response = yield call(addHousholdDataUpload)
    yield put(addHouseholdDataUploadSuccess(response))
    toast.success("Data uploaded successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(addHouseholdDataUploadFail(error))
    toast.success("Data upload failed", { autoClose: 2000 })
  }
}

function* onAddSubject({ payload: subject }) {
  try {
    const response = yield call(addSubject, subject)
    yield put(addSubjectSuccess(response))
  } catch (error) {
    yield put(addSubjectFail(error))
  }
}

function* onUpdateSubject({ payload: subject }) {
  try {
    const response = yield call(updateSubject, subject)
    yield put(updateSubjectSuccess(response))
  } catch (error) {
    yield put(updateSubjectFail(error))
  }
}

function* fetchSubjectDetail({ rowID }) {
  try {
    const response = yield call(getSubjectDetail, rowID)
    yield put(getSubjectDetailSuccess(response))
  } catch (error) {
    yield put(getSubjectDetailFail(error))
  }
}

function* householdSaga() {
  yield takeEvery(GET_HOUSEHOLDS, fetchHouseholds)
  yield takeEvery(GET_HOUSEHOLD_DETAIL, fetchHouseholdDetail)
  yield takeEvery(GET_TRAININGMONTHS, fetchTrainingMonths)
  yield takeEvery(ADD_HOUSEHOLD, onAddHousehold)
  yield takeEvery(UPDATE_HOUSEHOLD, onUpdateHousehold)
  yield takeEvery(GET_TRAININGTYPES, fetchTrainingTypes)
  yield takeEvery(GET_TRAININGSUBJECTS, fetchTrainingSubjects)
  yield takeEvery(ADD_HOUSEHOLD_FILEUPLOAD, onAddHouseholdBulkFile)
  yield takeEvery(ADD_HOUSEHOLD_DATAUPLOAD, onAddHousholdDataUpload)
  yield takeEvery(ADD_SUBJECT, onAddSubject)
  yield takeEvery(UPDATE_SUBJECT, onUpdateSubject)
  yield takeEvery(GET_SUBJECT_DETAIL, fetchSubjectDetail)
}

export default householdSaga
